/* 🤖 this file was generated by svg-to-ts */
export const emperorIconStarCircle: {
  name: 'star_circle';
  data: string;
} = {
  name: 'star_circle',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12.0016" cy="12.0001" r="8.4" fill="none"/><path d="M12 2.00098C6.486 2.00098 2 6.48698 2 12.001C2 17.516 6.486 22.001 12 22.001C17.514 22.001 22 17.516 22 12.001C22 6.48698 17.514 2.00098 12 2.00098ZM16.285 17.501L12 14.666L7.714 17.501L9.708 12.917L6 9.78698H10.285L12 5.50098L13.714 9.78698H18L14.292 12.917L16.285 17.501Z"/></svg>`
};
